// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3P2fM","name":"ConsentHeader_name__3hagF","birthday":"ConsentHeader_birthday__38UkJ","skeleton":"ConsentHeader_skeleton__2WlR6"};